// src/utils/adminChallengesApi.js
//
// The « Défi du mois » of the YummiTracker lists, admin side (backend
// routes/adminChallenges.ts, admins only). Errors carry the backend's code in
// err.message (TITLE_REQUIRED, ENDS_BEFORE_START, ...).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
const BASE = `${API_BASE_URL}/admin/challenges`;

async function call(method, path, token, body) {
  const r = await fetch(`${BASE}${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(data.error || `HTTP_${r.status}`);
    err.status = r.status;
    throw err;
  }
  return data;
}

export const listChallenges = (token) => call('GET', '', token);
export const createChallenge = (input, token) => call('POST', '', token, input);
export const updateChallenge = (id, input, token) => call('PUT', `/${Number(id)}`, token, input);
export const deleteChallenge = (id, token) => call('DELETE', `/${Number(id)}`, token);
export const deleteEntry = (id, token) => call('DELETE', `/entries/${Number(id)}`, token);

const ERRORS = {
  TITLE_REQUIRED: 'Donnez un titre au défi.',
  INVALID_DATES: 'Dates invalides.',
  ENDS_BEFORE_START: 'La fin doit être après le début.',
};
export const challengeErrorText = (e) => ERRORS[e?.message] || 'Erreur, réessayez.';
